import {apiConnector} from "../../lib/apiConnector";

export const actions = {
	// 表示用のメッセージデータを作成する
	login: async ({state, commit}, param) => {	// eslint-disable-line no-unused-vars
		// エラーは一旦クリアします
		commit('setLoginError', '');
		const rslt = await apiConnector.loginApi(param);
		console.log('login response', rslt);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setLogin', payload.login);
			commit('setController', payload.controller);
			commit('setAccessToken', payload.token);
			commit('setMonthlyStatus', null);
		} else if(rslt.status == 'error') {
			commit('setLogin', false);
			commit('setLoginError', rslt.error.msg);
		}
		return rslt;
	},
	// ログアウト
	logout: async ({getters, commit}) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.logoutApi(param);
		commit('logout');
		return rslt;
	},
	// ユーザー情報を取得する
	user: async ({commit, getters}) => {
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.userApi(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setUserName', payload.name);
		} else if(rslt.status == 'error') {
			//commit('setLoginError', rslt.error.msg);
		}
	},
	// ランステに関する月額会員、チケット会員、最終利用日時を取得する
	runstStatus: async ({commit, getters}) => {
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.runstStatusApi(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setUserName', payload.name);
			commit('setMonthlyStatus', payload.monthly);
			commit('setTicketStatus', payload.ticket);
			commit('setListTicket', payload.ticketList);
			commit('setListMonthly', payload.monthlyList);
			commit('setListHalfAnnual', payload.halfAnnualList);
			commit('setListAnnual', payload.annualList);
			commit('setRunstReception', payload.reservation);
		} else if(rslt.status == 'error') {
			//commit('setLoginError', rslt.error.msg);
		}
	},
	// ランステ受付で提示するQRコードを取得する
	getAuthQrcode: async({commit, getters}) => {	// eslint-disable-line no-unused-vars
		commit('setCodeQqCheckin', '');
		const param = {
			'access_token': getters['getAccessToken']
		};
		const rslt = await apiConnector.loginApi(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setCodeQqCheckin', payload.qr_toekn);
			commit('setAccessToken', payload.token);
			commit('setUserName', payload.name);
		} else if(rslt.status == 'error') {
			commit('setApiError', rslt.error.msg);
		}
		return rslt;
	},
	// ランステ利用状況を取得する
	apiRunstLog: async({commit, getters}) => {	// eslint-disable-line no-unused-vars
		commit('setRunningRunstLog', true);
		const param = {
			'token': getters['getAccessToken']
		};
		const rslt = await apiConnector.runstLogApi(param);
		commit('setRunningRunstLog', false);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			if(payload.history) {
				commit('setListRunstLog', payload.history);
			}
		} else if(rslt.status == 'error') {
			commit('setApiError', rslt.error.msg);
		}
		return rslt;
	},
	// ランステチケット利用状況を取得する
	apiTicketLog: async({commit, getters}) => {	// eslint-disable-line no-unused-vars
		commit('setRunningTicketLog', true);
		const param = {
			'token': getters['getAccessToken']
		};
		const rslt = await apiConnector.ticketLogApi(param);
		commit('setRunningTicketLog', false);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			if(payload.history) {
				commit('setListTicketLog', payload.history);
			}
			if(payload.ticket) {
				commit('setTicketStatus', payload.ticket);
			}
		} else if(rslt.status == 'error') {
			commit('setApiError', rslt.error.msg);
		}
		return rslt;
	},
	// ランステ月額会員利用状況を取得する
	apiMonthlyLog: async({commit, getters}) => {	// eslint-disable-line no-unused-vars
		commit('setRunningMonthlyLog', true);
		const param = {
			'token': getters['getAccessToken']
		};
		const rslt = await apiConnector.monthlyLogApi(param);
		commit('setRunningMonthlyLog', false);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			if(payload.history) {
				commit('setListMonthlyLog', payload.history);
			}
			if(payload.monthly) {
				commit('setMonthlyStatus', payload.monthly);
			}
			// ランステ月額自動継続フラグ
			commit('setAutoMonthlyFlag', payload.auto);
		} else if(rslt.status == 'error') {
			commit('setApiError', rslt.error.msg);
		}
		return rslt;
	},
	
	/* これらは不要になっています
	// 一括決済を申し込む（テスト用）
	batchSubscription: async({getters}) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken'],
			};
		const rslt = await apiConnector.batchSubscription(param);
		return rslt;
	},

	// 一括決済を照会する（テスト用）
	searchBatchSubscription: async({getters}) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken'],
			};
		const rslt = await apiConnector.searchBatchSubscription(param);
		return rslt;
	},
	*/

	// 月額ステータスを取得する
	monthlyStatus: async ({commit, getters}) => {
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.monthlyStatusApi(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setMonthlyStatus', payload.monthly);
		} else if(rslt.status == 'error') {
			//commit('setLoginError', rslt.error.msg);
		}
	},
	
	// ランステ受付を開始する
	receptionRunst: async ({commit, getters}) => {
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.receptionRunst(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			if(payload.name) {
				commit('setRunstReception', payload);
			}
		} else if(rslt.status == 'error') {
			//commit('setLoginError', rslt.error.msg);
		}
		return rslt && rslt.payload ? rslt.payload : null;
	},
	// ランステ受付(チケット)を開始する
	receptionRunstTicket: async ({commit, getters}) => {
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.receptionRunstTicket(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setRunstReception', payload);
		} else if(rslt.status == 'error') {
			//commit('setLoginError', rslt.error.msg);
		}
	},
	// ランステ受付結果をポーリングする
	checkReceptionStatus: async ({getters}) => {
		const response = getters['getResponseRunstReception'];
		if(!response || !response.token) return null;
		
		const param = {
			token: response.token
		};
		const rslt = await apiConnector.checkReceptionStatus(param);
		return rslt;
	},

	// 予約状況の取得
	listupReservations: async ({getters, commit}, inparam) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken'],
			...inparam
		};
		const rslt = await apiConnector.listupReservations(param);
		if(rslt && rslt.payload && rslt.payload.reservations) {
			commit('setListReservation', rslt.payload.reservations);
		}
		return rslt;
	}, 

	// プロファイルを取得する
	profile: async ({commit, getters}) => {
		const param = {
			token: getters['getAccessToken']
		};
		const rslt = await apiConnector.profileApi(param);
		if(rslt.status == 'success') {
			const payload = rslt.payload;
			commit('setProfile', payload.user);
		} else if(rslt.status == 'error') {
			//commit('setLoginError', rslt.error.msg);
		}
		return rslt;
	},
	// ユーザー情報を取得する
	ajaxZip: async ({commit, getters}, zipcode) => {	// eslint-disable-line no-unused-vars
		return await apiConnector.ajaxZip(zipcode);
	},
	// プロフィールのバリデーションチェック
	validateProfile: async ({getters}, inparam) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken'],
			...inparam
		};
		const rslt = await apiConnector.validateProfileApi(param);
		return rslt;
	},
	// プロフィールの更新
	updateProfile: async ({getters}, inparam) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken'],
			...inparam
		};
		const rslt = await apiConnector.updateProfileApi(param);
		return rslt;
	}, 
	
	// ポイント情報を取得する
	pointInfo: async ({commit, getters}) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: getters['getAccessToken'],
		};
		const rslt = await apiConnector.pointInfoApi(param);
		if(rslt && rslt.payload) {
			commit('setUfPoint', rslt.payload.point);
			commit('setPointLog', rslt.payload.log);
		}
		return rslt;
	}, 

	// パスワード忘れ
	lostPassword: async ({commit, getters}, inparam) => {	// eslint-disable-line no-unused-vars
		commit('setLoading', true);
		const param = {
			...inparam
		};
		const rslt = await apiConnector.lostPasswordApi(param);
		if(rslt && rslt.payload) {
			//
		}
		commit('setLoading', false);
		return rslt;
	}, 

	// 予約システム用のトークンを取得するパスワード忘れ
	getServiceToken: async ({commit, getters}) => {	// eslint-disable-line no-unused-vars
		commit('setLoading', true);
		const param = {
			token: getters['getAccessToken'],
			service_type: 0,	// ランステのサービスタイプ
			to_service_type: 1,	// 予約システムのサービスタイプ
		};
		const rslt = await apiConnector.getServiceToken(param);
		if(rslt && rslt.payload) {
			//
		}
		commit('setLoading', false);
		return rslt;
	}, 

};

export default {
	actions
};